import { useTranslation } from "react-i18next";
import Product from 'components/product/Product';
import {getData} from "components/product/util";

import img1 from 'assets/images/solutions/modules/hd/module_07.png'
import img2 from 'assets/images/solutions/modules/hd/module_08.png'
import img3 from 'assets/images/solutions/modules/hd/module_09.png'
import img4 from 'assets/images/solutions/modules/hd/module_10.png'

export default function ProductHd(){
  const {t} = useTranslation();
  const products = getData(t, "modules", "hd");
 
  // 그림 이름은 대중이 없어서 따로 넣어야 함.
  products[0].images = [img1];
  products[1].images = [img2];
  products[2].images = [img3];
  //products[3].images = [img4];

  //추가 정보..
  for(let i = 0; i < 3; i++){
    const modelInfo = [];
    const infoCountStr = t(`modules.company.hd.products.${i+1}.model-info.count`) ?? 0;
    const infoCount = infoCountStr!==undefined? +infoCountStr: 0;
    for(let j = 1; j < infoCount+1; j++)
      modelInfo.push(t(`modules.company.hd.products.${i+1}.model-info.comment-${j}`))

    products[i].modelInfo = modelInfo;
  } 

  return (
    <Product products={products}/>
  );
}